import React, {createContext, useContext, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {loginChannel} from '../../../utils';
import {RootState} from '../../../../store/configureStore';
import {pathnames as P} from '../../../enums';

export type AuthContext = {
  handleLogin: () => Promise<void>
}

export interface GlobalContextProviderProps {
  children: React.ReactNode;
}

export const defaultContext: AuthContext = {
  handleLogin: async () => {},
};

export const AuthContext = createContext<AuthContext>(defaultContext);
AuthContext.displayName = 'AuthContext';

export const useAuthContext = () => useContext(AuthContext);

export const AuthContextProvider = ({children}: GlobalContextProviderProps) => {
  const navigate = useNavigate();
  const currentToken = useSelector((state: RootState) => state.auth.token);

  const goBack = () => {
    navigate(P.HOME);
  };

  useEffect(() => {
    if (currentToken) {
      goBack();
    }
  }, []);

  useEffect(() => {
    loginChannel.addEventListener('message', () => {
      window.location.href = P.HOME;
    });
  }, []);

  const handleLogin = async () => {
    await loginChannel.postMessage('Login');
  };

  const context: AuthContext = {
    ...defaultContext,
    handleLogin,
  };

  return (
    <AuthContext.Provider value={context}>
      {children}
    </AuthContext.Provider>
  );
};
